import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { accountQuery, cmsPagesQuery, hostBaseUrl } from '@/api';
import { PopupType, promoPopupFromPages, type PromoPopup } from '@/domain';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { useIsDesktop } from '@/lib/useMediaQuery';

/** Active CMS promo popup for the current viewport, or null when none. */
export function usePromoPopup(): PromoPopup | null {
  const { data: account } = useQuery(accountQuery());
  const { selectedLanguage } = useTranslations();
  const isDesktop = useIsDesktop();
  const accountGuid = account?.Guid ?? '';
  const popupType = isDesktop
    ? PopupType.DesktopEverywhere
    : PopupType.MobileEverywhere;

  const { data } = useQuery({
    ...cmsPagesQuery(accountGuid, selectedLanguage),
    enabled: Boolean(accountGuid && selectedLanguage),
  });

  return useMemo(() => {
    if (!accountGuid || !data?.Data) return null;
    return promoPopupFromPages(
      data.Data,
      popupType,
      hostBaseUrl('users'),
      accountGuid,
    );
  }, [accountGuid, data, popupType]);
}
